import { Injectable } from '@angular/core';
import { AuthService } from '@anduin/auth';
import { ConfigService, Globals } from '@anduin/config';
import { fromSync } from '@anduin/shared';
import { SpaceApi, loadSpace } from '@usersnap/browser';
import { Observable } from 'rxjs';

const STAFF_ID_POLL_INTERVAL_MS = 2000;
const STAFF_ID_POLL_TIMEOUT_MS = 300_000;

@Injectable({
  providedIn: 'root',
})
export class UsersnapService {
  private script: HTMLScriptElement | null = null;
  public usersnapApi: SpaceApi | null = null;

  constructor(
    private readonly configService: ConfigService,
    private globals: Globals,
    private authService: AuthService,
  ) {}

  initialize(initParams = {}) {
    return new Promise<SpaceApi>((resolve) => {
      loadSpace(this.configService.usersnapSpaceApiKey).then((api) => {
        this.waitForStaffId$().subscribe((staffId) => {
          api.init({
            ...initParams,
            user: {
              userId: staffId.toString(),
              email: this.authService.getEmail(),
              tenant: this.globals.anTenant,
            },
          });
          this.usersnapApi = api;
          resolve(api);
        });
      });
    });
  }

  // AuthService has no emission for "staffId claim has landed on the JWT" — poll until getStaffId() is populated
  // so Usersnap never inits with a missing user block.
  private waitForStaffId$(): Observable<number> {
    return fromSync(() => this.authService.getStaffId(), STAFF_ID_POLL_TIMEOUT_MS, STAFF_ID_POLL_INTERVAL_MS);
  }
}
